import React, { useContext, useEffect } from 'react';
import { AppDomain } from "../Constants/EnvConstants";
import VisitorParamsContext from "../Contexts/VisitorParams";

const GetVisitorsParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const referrer = document.referrer;
  const { visitorParameters } = useContext(VisitorParamsContext);
  const full_url = window.location.href;
  const query_string_arr = full_url.split("?");
  var queryString = "";
  if (query_string_arr != null) {
    queryString = query_string_arr[1];
  }
  useEffect(() => {
    (async () => {
      if (visitorParameters.data.length === 0 || visitorParameters.data === null ||
        visitorParameters.data === undefined) {
        const query_uuid = urlParams.get("uuid");
        const local_storage_uuid = localStorage.getItem('uuid');
        var uuid = (query_uuid) ? query_uuid : local_storage_uuid;
        const response = {
          user_agent : window.navigator.userAgent,
          page_type:"LP",
          domain_name:AppDomain,
          existingdomain:window.location.href,
          referer_site:referrer
        };
        visitorParameters.data = response;
        visitorParameters.visitor_parameters = { uuid: uuid };
      }
    })()
  }, [])
}

export default GetVisitorsParams;